import React from 'react';
import { ROUTES } from './constants';
import { Route } from 'circe/routing/provider';
import { Loadable } from 'circe/loadable/provider';
import { AUTHORITIES } from 'domain/fuse/auth/constants';
import RequireAuth from 'circe/authorization/components/AuthorizationRoute';
import LoadingIndicator from 'domain/layout/components/LoadingIndicator';

const Container = Loadable({
  loader: () => import('./container'),
  loading: (e) => {
    return <LoadingIndicator />;
  },
});

const authorizedContainer = RequireAuth(Container, [AUTHORITIES.FINANCE_ADMIN], '/');

const Routes = () => <Route path={ROUTES.ROOT} key={ROUTES.ROOT} component={authorizedContainer} />;

export default Routes;
